import { useCallback, useEffect, useState } from 'react';
import {
  getWaitlistEntry,
  saveWaitlistEntry,
  type WaitlistEntry,
} from '@/lib/storage';

export interface UseWaitlistResult {
  submitted: boolean;
  submit: (entry: WaitlistEntry) => void;
  entry: WaitlistEntry | null;
}

export function useWaitlist(): UseWaitlistResult {
  const [entry, setEntry] = useState<WaitlistEntry | null>(null);
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    const existing = getWaitlistEntry();
    if (existing) {
      setEntry(existing);
      setSubmitted(true);
    }
  }, []);

  const submit = useCallback((newEntry: WaitlistEntry) => {
    saveWaitlistEntry(newEntry);
    setEntry(newEntry);
    setSubmitted(true);
  }, []);

  return { submitted, submit, entry };
}
